import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAction } from "@helium10/re-core";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { useDebouncedCallback } from "use-debounce";
import { useKeys } from "../../../core/hooks/useKeys";
import { NakedInput } from "../../newCommon/ControlsCommon";
import { FillByText } from "../../newCommon/FillByText";
import { setSearchStringAction, setValueAction } from "./selectStore";
export const useAutocomplete = ({ isOpen }) => {
    const inputRef = useRef(null);
    const setSearchString = useAction(setSearchStringAction);
    const [search, setSearch] = useState("");
    const handleCalculate = useDebouncedCallback(() => setSearchString(search), 200);
    useEffect(() => {
        handleCalculate();
    }, [handleCalculate, search]);
    useEffect(() => {
        isOpen ? inputRef?.current?.focus() : inputRef?.current?.blur();
    }, [isOpen]);
    const handleInputChange = useCallback((e) => setSearch(e.target.value), []);
    return {
        search,
        inputRef,
        handleInputChange,
    };
};
export const DisplayAutocomplete = memo((props) => {
    const { selected, placeholder } = props;
    const { search, handleInputChange, inputRef } = useAutocomplete(props);
    const [focused, setFocused] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(AutocompleteInput, { onFocus: () => setFocused(true), onBlur: () => setFocused(false), ref: inputRef, value: search, onChange: handleInputChange }), !search ? (selected.length > 0 ? (_jsx(AutocompleteValue, { "$hide": focused, "data-hide": focused, children: selected[0]?.label })) : (_jsx(AutocompletePlaceholder, { children: placeholder }))) : null] }));
});
export const MultiAutocomplete = memo((props) => {
    const { isOpen, selected, placeholder, renderValueTags, disabled } = props;
    const { search, handleInputChange, inputRef } = useAutocomplete(props);
    useEffect(() => {
        isOpen ? inputRef?.current?.focus() : inputRef?.current?.blur();
    }, [inputRef, isOpen]);
    const setValue = useAction(setValueAction);
    const handleClickBackspace = () => {
        if (!search && selected.length > 0) {
            setValue(selected[selected.length - 1]);
        }
    };
    const handleKeyDown = useKeys({
        Backspace: handleClickBackspace,
    });
    const handleValueClick = useCallback((option) => {
        if (!option.disabled) {
            setValue(option);
        }
    }, [setValue]);
    return (_jsxs(_Fragment, { children: [renderValueTags(selected.map((option) => ({
                option,
                onClick: handleValueClick,
            }))), _jsx(InputContainer, { value: search, placeholder: placeholder, children: _jsx(MultiAutocompleteInput, { onKeyDown: handleKeyDown, placeholder: placeholder, ref: inputRef, value: search, disabled: disabled, onChange: handleInputChange }) })] }));
});
export const InputContainer = styled(FillByText) ``;
export const AbsoluteValue = css `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const AutocompleteValue = styled.div `
  ${AbsoluteValue};

  ${({ $hide: hide }) => hide &&
    css `
      opacity: 0.5;
    `}
`;
export const AutocompletePlaceholder = styled.div `
  ${AbsoluteValue};
`;
export const AutocompleteInput = styled(NakedInput) ``;
const MultiAutocompleteInput = styled(AutocompleteInput) `
  ${FillByText.ContentStyles};
`;
